import React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

import { Color } from "../../constants/colors";


export default function WhatsAppPlayAudioIcon(props: any) {

  const { style, viewBox, ...otherProps } = props;

  return (
    <SvgIcon
      {...otherProps}
      style={{ width: 22, height: 23, ...style }}
      viewBox={viewBox || "0 0 22 23"}
      fill="none"
    >
      <path
        d="M4.49203 22.2729C2.50558 23.3232 0 22.0361 0 19.9649V3.12733C0 1.05614 2.50558 -0.230961 4.49203 0.819063L20.4207 9.2371C22.3807 10.2723 22.3807 12.8179 20.4207 13.8533L4.49203 22.2729Z"
        fill={style?.color || Color.gray5}
      />
    </SvgIcon>
  );
}